import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic MATTE KLAR reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fyw1ajdmptfb">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3azjdnwexoibo">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3ayhx5cf5f3mk">
          Co <em className="text-red-700" data-id="element-274" data-mp="31zw951qwqwee">učitelé</em> říkají
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31yl4z0tjvmmr">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2x2mm1sqzqwtq">
              <div className="text-sm text-amber-500" aria-label="5 z 5 hvězdiček" data-id="element-277" data-mp="2s39q8ii56ff0">
                <span aria-hidden="true" data-id="element-278" data-mp="v8591v8ft91q">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="q9u0dntvp4l3">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h816vm00ecjf">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m5b3blltfogr">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="780mrxubfse6"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}